import React from "react";
import moment from "moment-timezone";
import { Delete } from "@mui/icons-material";
import { Box, Checkbox, FormControlLabel, styled } from "@mui/material";

import { DialogConfirm } from "../../../../pages/Customer/components";

export interface INote {
  id: number;
  note: string;
  create_date: string;
  is_active: boolean;
  admin_account: {
    id: number;
    name: string;
  };
}

interface IProps {
  report: INote[];
  handleDeleteNote: (noteId: number) => Promise<void>;
  handleChangeStatus: (noteId: number, isActive: boolean) => Promise<void>;
  isAllowedChangeStatusAndRemoveActions: boolean;
}

const Tr = styled("tr")<{ is_active: boolean }>(({ is_active }) => ({
  ...(is_active && {
    borderSpacing: 0,
    "& td": { background: "#ffff003b" },
  }),
}));

const TableData: React.FC<IProps> = ({
  report,
  handleDeleteNote,
  handleChangeStatus,
  isAllowedChangeStatusAndRemoveActions,
}) => {
  return (
    <Box
      component="table"
      sx={{
        borderSpacing: 0,
        "& tr": {
          wordBreak: "break-word",
        },
      }}
      mt="7px"
      width="100%"
    >
      <tbody>
        {[...report]
          .sort((a, b) => b.id - a.id)
          .map((noteData) => (
            <React.Fragment key={noteData.id}>
              <Tr is_active={noteData.is_active}>
                <Box
                  component="td"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ "& p": { margin: 0 } }}
                >
                  <Box display="flex" alignItems="center">
                    {isAllowedChangeStatusAndRemoveActions && (
                      <>
                        <DialogConfirm
                          isShowMainButton={false}
                          dialogTitle="Delete note"
                          contentText="Are you sure you want to delete note ?"
                          buttonText="delete"
                          onClickConfirm={() => handleDeleteNote(noteData.id)}
                          ButtonComponent={Delete}
                          externalStyles={{ color: "#e53935", cursor: "pointer" }}
                        />
                        <FormControlLabel
                          sx={{ marginLeft: 0 }}
                          control={
                            <Checkbox
                              checked={noteData.is_active}
                              onChange={() => handleChangeStatus(noteData.id, !noteData.is_active)}
                              name="inactive"
                            />
                          }
                          label={noteData.is_active ? "Active" : "Inactive"}
                        />
                      </>
                    )}
                  </Box>
                  <div>
                    <p data-test="created-date">
                      {moment(noteData.create_date)
                        .tz("America/Chicago")
                        .format("YYYY-MM-DD HH:mm")}
                    </p>
                    <p>
                      {noteData.admin_account
                        ? `${noteData.admin_account?.name}(${noteData.admin_account?.id})`
                        : "Internal"}
                    </p>
                  </div>
                </Box>
              </Tr>
              <Tr is_active={noteData.is_active}>
                <Box
                  component="td"
                  sx={{ ...(report.length > 1 && { borderBottom: "1px solid rgba(0,0,0,.2)" }) }}
                >
                  {noteData.note}
                </Box>
              </Tr>
            </React.Fragment>
          ))}
      </tbody>
    </Box>
  );
};

export default TableData;
